import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import TextInput from '../../../core/form/TextInput';
import FormButtons from '../../../core/form/FormButtons';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import LocalFileInput from '../../../core/form/LocalFileInput';
import MaskInput from '../../../core/form/MaskInput';
import Button from '../../../core/form/Button';

const WebPageForm = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      <Column size={3}>
        <TextInput
          required
          disabled={props.submitting}
          label="Name"
          value={get(props.values, 'name', '')}
          onChange={(value) => props.onChange('name', value)}
          errorText={get(props.errors, 'name', null)}
        />
      </Column>
      {props.values.slug && (
        <>
          <Column size={2.5}>
            <TextInput
              disabled={true}
              label="Web page link"
              value={`https://flexge.com/pt/professores/${get(props.values, 'slug', '')}`}
            />
          </Column>
          <Column size={0.5}>
            <div style={{ height: 43 }} />
            <Button
              icon="export"
              onClick={() =>
                window.open(`https://flexge.com/pt/professores/${get(props.values, 'slug', '')}`, '_blank')
              }
            />
          </Column>
        </>
      )}
      <Column size={1.5}>
        <LocalFileInput
          disabled={props.submitting}
          value={get(props.values, 'profilePictureUrl', null)}
          onChange={(value) => props.onChange('profilePictureFile', value)}
          label="Profile Picture"
          accept="image"
        />
      </Column>
      <Column size={4}>
        <LocalFileInput
          disabled={props.submitting}
          value={get(props.values, 'promotionVideoUrl', null)}
          onChange={(value) => {
            props.onChange('promotionVideoFile', value);
            props.onChange('promotionVideoFileSize', value.size);
          }}
          label="Profile video"
          accept="video"
        />
      </Column>
    </Row>
    <Row>
      <Column size={12}>
        <TextInput
          required
          disabled={props.submitting}
          label="About"
          fieldType="textarea"
          textAreaRows={4}
          value={get(props.values, 'about', '')}
          onChange={(value) => props.onChange('about', value)}
          errorText={get(props.errors, 'about', null)}
        />
      </Column>
    </Row>
    <Row>
      <Column size={3}>
        <MaskInput
          required
          disabled={props.submitting}
          maskType="phone"
          label="WhatsApp number"
          value={get(props.values, 'whatsappNumber', '')}
          onChange={(value) => props.onChange('whatsappNumber', value)}
          errorText={get(props.errors, 'whatsappNumber', null)}
        />
      </Column>
      <Column size={3}>
        <TextInput
          disabled={props.submitting}
          label="Facebook"
          value={get(props.values, 'facebookUrl', '')}
          onChange={(value) => props.onChange('facebookUrl', value)}
          errorText={get(props.errors, 'facebookUrl', null)}
        />
      </Column>
      <Column size={3}>
        <TextInput
          disabled={props.submitting}
          label="Instagram"
          value={get(props.values, 'instagramUrl', '')}
          onChange={(value) => props.onChange('instagramUrl', value)}
          errorText={get(props.errors, 'instagramUrl', null)}
        />
      </Column>
      <Column size={3}>
        <TextInput
          disabled={props.submitting}
          label="LinkedIn"
          value={get(props.values, 'linkedInUrl', '')}
          onChange={(value) => props.onChange('linkedInUrl', value)}
          errorText={get(props.errors, 'linkedInUrl', null)}
        />
      </Column>
    </Row>
    <FormButtons
      confirmLabel="Save"
      isDisabled={props.submitting || !props.isDirty()}
      isSubmitting={props.submitting}
      onReset={props.onReset}
    />
  </form>
);

WebPageForm.propTypes = {
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
};

WebPageForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  isDirty: () => false,
  onSubmit: () => alert('submitted'),
  onReset: () => false,
};

export default WebPageForm;
